import React from "react"
import { Dispatch } from "redux"

import { replaceHistoryState } from "client/utils"
import { addModal } from "client/store"

import ComplianceAnswer from "client/pages/cc/compliance/answer"

const Open = (
    setId: number,
    revisionId: number,
    itemId: number,
    baseRoute: string,
    dispatch: Dispatch,
) => {
    replaceHistoryState(`${baseRoute}/set/${setId}/revision/${revisionId}/item/${itemId}`)

    dispatch(addModal({
        key: "answer",
        content: <ComplianceAnswer setId={setId} revisionId={revisionId} itemId={itemId} />,
        onClose: () => {
            replaceHistoryState(baseRoute)
        },
    }))
}
export default Open
